import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import Home from "./pages/Home";

function ScrollToSectionOnLoad() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      scroller.scrollTo(location.state.scrollTo, {
        smooth: true,
        duration: 600,
        offset: -80,
      });
    }
  }, [location]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToSectionOnLoad />
      <Header />
      <main style={{ paddingTop: "60px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
